
import makerjs from "makerjs";
function A12(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,W1 = Param[1].param, H = Param[2].param,H1 = Param[3].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
       w1 = W1 * 1 * myZoom,
       h1 = H1 * 1 * myZoom,
       w = W * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = 0, x2 = w, x3 = w1, y0 = 0, y1 = h, y2 = h1, y3 = 0,glassH = h, glassW = w;

   if (h !== 0) {
       var TxtH = H;
   } if (w1 !== 0) {
    var TxtW1 = W1;
} if (h1 !== 0) {
  var TxtH1 = H1;
}
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeA12 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
        "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
        "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeA12MarkH = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0 - markShift, y0], [x0 - markShift, y1]),
        "LeftShortUpline": new makerjs.paths.Line([x1, y1], [x0 - 2 * markShift, y1]),
        "LeftShortDnline": new makerjs.paths.Line([x0, y0], [x0 - 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeA12MarkW = {
       paths: {
        "UpLine": new makerjs.paths.Line([x1, y1+ markShift], [x2, y1 + markShift]),
        "UpShortLfline": new makerjs.paths.Line([x1, y1], [x1, y1 + 2 * markShift]),
        "UpShortRTline": new makerjs.paths.Line([x2, y1], [x2, y1 + 2 * markShift]),
       }
   };
   var drawAbnormalShapeA12MarkH1 = {
       paths: {
        "RightLine": new makerjs.paths.Line([x2+ markShift, y3], [x2+ markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x2, y2], [x2+ 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x2, y3], [x2+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeA12MarkW1 = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x3, y3 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA12MarkW1, TxtW1, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeA12MarkW, TxtW, [x1, y1 + 2 * markShift], [x2, y1 + 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeA12MarkH1, TxtH1, [x2 + 2 * markShift, y3], [x2 + 2 * markShift, y2]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeA12MarkH, TxtH, [x0 - 2 * markShift, y0], [x0 - 2 * markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA12: drawAbnormalShapeA12,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA12: drawAbnormalShapeA12,
        drawAbnormalShapeA12MarkW1: drawAbnormalShapeA12MarkW1,
        drawAbnormalShapeA12MarkH1: drawAbnormalShapeA12MarkH1,
        drawAbnormalShapeA12MarkH:drawAbnormalShapeA12MarkH,
        drawAbnormalShapeA12MarkW:drawAbnormalShapeA12MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A12;